import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import * as moment from 'moment-timezone';

import {environment} from '../../environments/environment';
import {ScheduleData, ShowsResponse, Show} from './schedule.model';
import {AngularPageVisibilityStateEnum} from 'angular-page-visibility';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  private timer;

  private focused = true;

  public scheduleData = new BehaviorSubject<ScheduleData>({current: undefined, upcoming: undefined});

  constructor(private http: HttpClient) {
  }

  initSchedule(): void {
    this.updateScheduleData();
    this.startPolling();
  }

  private getShowLogoUrl(show: Show) {
    if (show.image_path && show.image_path.length) {
      return environment.logoApiEndpoint + '?id=' + show.id;
    } else {
      return '';
    }
  }

  private processShowData(show: Show): Show {
    show.name = show.name.replace('$$$', '');

    if (show.name.match(/LIVE/)) {
      show.name = '🔴 ' + show.name;
    }

    if (show.name.match(/PREMIERE/)) {
      show.name = '🌟 ' + show.name;
    }

    show.image_path = this.getShowLogoUrl(show);

    return show;
  }

  public updateScheduleData(): void {
    this.http.get(environment.scheduleApiEndpoint).subscribe((data: ShowsResponse) => {
      data.shows.next.forEach((s, i) => {
        data.shows.next[i] = this.processShowData(s);
      });

      data.shows.current = this.processShowData(data.shows.current);

      const newSchedule = {
        current: data.shows.current,
        upcoming: data.shows.next
      };

      if (this.scheduleData.value !== newSchedule) {
        this.scheduleData.next(newSchedule);
      }
    });
  }

  private startPolling(): void {
    this.timer = setTimeout(() => {
      if (this.focused) {
        this.updateScheduleData();
      }
      this.startPolling();
    }, environment.schedulePollInterval * 1000);
  }

  public visibilityChange(visibilityState: AngularPageVisibilityStateEnum): void {
    if (AngularPageVisibilityStateEnum[visibilityState] === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.VISIBLE]) {
      this.focused = true;
    } else if (AngularPageVisibilityStateEnum[visibilityState] === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.HIDDEN]) {
      this.focused = false;
    }
  }

  /**
   * Converts datetime string to user's local time zone and formats
   * the datetime as HH:ss (hour:minute)
   */
  public formatTime(date: string): string {
    const vilniusTime = moment.tz(date, 'Europe/Vilnius');
    const currentTimeZone = moment.tz.guess();
    const localTime = vilniusTime.clone().tz(currentTimeZone).format('HH:mm');
    return localTime;
  }
}
